define('drops/documentView/documentView',[
    'jquery',
    'lq/drop',
    'lq/style',
    'lq/util',
    'lq/imageSize',
    'lq'
], function ($, Drop, Style, util, imageSize, lq) {
    'use strict';

    // NOTE THIS IS NOT FINAL CODE, THIS DROP NEEDS TO BE REMOVED LATER ON
    // BE CAREFUL: UGLY CODE!!
    function DocumentView(options) {
        Drop.call(this, $('<div/>'), options);

        this.$element
            .css({
                whiteSpace: 'pre-wrap'
            });

        Style.renderStyles(this);

        this.$element
            .height(this.data.size.y)
            .width(this.data.size.x);

        this.$a = $('<a/>')
            .css({
                display: 'inline-block'
            })
            .height(this.data.size.y)
            .width(this.data.size.x)
            .appendTo(this.$element);

        this.$span = $('<span/>')
                    .css({
                        height: this.data.size.y + 'px'
                    })
            .appendTo(this.$a);

        this.$img = $('<img/>')
            .css({
                verticalAlign: 'middle'
            })
            .height(this.data.iconSize)
            .width(this.data.iconSize)
            .appendTo(this.$span);

        if (this.data.downloadText) {
            this.$spanDownloadText = $('<span/>')
                .css({
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    paddingLeft: '4px'
                })
                .text(this.data.downloadText)
                .appendTo(this.$span);
        }

        if (!this.data.showIcon) {
            this.$img.hide();
            
            if (this.data.downloadText) {
            	this.$spanDownloadText
					.css({
						paddingLeft: '0px'
					});
            }
        }
        this.hide();

        return this;
    };

    Drop.extend(DocumentView, Drop);

    DocumentView.typeName = 'DocumentView';

    DocumentView.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
    };

	DocumentView.prototype.clearValue = function () {
        // todo : don't know what to clear here
    };

    DocumentView.prototype.setValue = function(update) {
        var value = util.convertListOfKeyValuesToObject(update.value);

        var url;
        var filename = '';

        if (!value) {
            return;
        } else if ($.type(value) === 'string') {
            url = value;
        } else {
            url = value.url || value.Url;
            filename = value.filename || value.Filename;
        }

        if (url) {
            this.$a.show();

            // If filename exists, set filename parameter
            if (filename) {
                filename = '&filename=' + filename;
            }

            var openInBrowser = '';
            // If the behaviour is either currentTab or newTab set the openInBrowser parameter to true
            if (this.data.behaviour === 'currentTab' || this.data.behaviour === 'newTab') {
                openInBrowser = '&openInBrowser=true';
            }

            this.$a.attr('href', lq.getTenantUrl('DynamicContent/DownloadFile?url=' + url + filename + openInBrowser));

            if (this.data.behaviour === 'newTab')
                this.$a.attr('target', '_blank');

            var requiredSize = imageSize.forElement(this.data.size);
            var src = lq.getTenantUrl('DynamicContent/Thumbnail/' + url + "?width=" + requiredSize.x + "&height=" + requiredSize.y + "&filetype=png&isMaxSize=true");
            this.$img.attr('src', src);

            //prevents clickthrough on listitems
            this.$a.on('click', function (event) {
                if (event.stopPropagation) { // W3C/addEventListener()
                    event.stopPropagation();
                } else { // Older IE.
                    event.cancelBubble = true;
                }
            })

        } else {
            this.$a.hide();
        }
        this.show();
    };

    return DocumentView;
});
